module.exports = __webpack_public_path__ + "img/10.794b994a.jpg";